export var NO_AVAILABLE_HOURS_MESSAGE = 'No available hours for the selected date';